/* eslint-disable */

// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'

import { Datetime } from 'vue-datetime';
import { VueEditor } from "vue2-editor";
import createQuizReward from '../../quizRewards/create-quiz-reward/index';
import draggable from "vuedraggable";
import { mapGetters } from 'vuex';
import toast from '@/services/toast';

var $ = window.jQuery = require('jquery');

export default {
  name: 'edit-interview-quiz',
  components: {
    datetime: Datetime,
    VueEditor,
    draggable,
    'quiz-reward':createQuizReward
  },
  props: [],
  data() {
    return {
      quizData: {
        courseId: '',
        name: '',
        category: '',
        instruction: '',
        quiz_number: 0,
        time_limit:90,
        isActive: false,
        quizId:'',
        create_datetime:'',
        end_datetime:'',
        is_visible:false,
        quiz_reward:[],
        testing_enabled:false,
        show_winners: false
      },
      submitted:false,
      unitListState:[],
      is_active:'',
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold','italic','link',  '|', 'heading', 'fontFamily','fontSize','undo','redo']
      },
      instruction:'',
      deleteRewardId:'',
      removeRewardPopupStatus:false,
      code:'',
      removeSectionOfQuizPopupStatus:false,
      removeSectionOfQuizId:'',
      minDatetime:new Date().toISOString(),
    }
  },
  computed: {
    ...mapGetters([
    ]),
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        ghostClass: "ghost"
      };
    },
  },
  mounted() {
    this.getQuizDetails();
    this.$store.dispatch('getIvQuizUniInfoAction').then((res) => {
      this.unitListState = res.data.data.results
    })
  },
  methods: {
    getQuizDetails() {
      this.$store.dispatch('getInterviewInfoByIdAction', {
        id: this.$route.params.quizId
      }).then((response) => {
        this.quizData.show_winners = response.data.data.show_winners;
        this.quizData.name = response.data.data.name
        this.quizData.isActive = response.data.data.is_active
        this.quizData.is_visible = response.data.data.is_visible
        this.quizData.instruction = response.data.data.instruction
        this.quizData.category = response.data.data.connected_to_unit
        this.quizData.quiz_number = response.data.data.quiz_number
        this.quizData.time_limit = response.data.data.time_limit
        this.quizData.create_datetime = response.data.data.start_time
        this.quizData.end_datetime = response.data.data.end_time
        this.quizData.quiz_reward = response.data.data.rewards
        this.quizData.testing_enabled = response.data.data.testing_enabled
        this.code = response.data.data.code
      })
    },
    clearEndTimePointFun(){
      this.quizData.end_datetime = ''
    },
    validateUpdateQuizBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            name: this.quizData.name,
            instruction: this.quizData.instruction,
            connected_to_unit: this.quizData.category,
            // quiz_number:this.quizData.quiz_number,
            start_time:this.quizData.create_datetime,
            // time_limit:this.quizData.time_limit,
            code:this.code,
            is_interview:true
          }
          if(this.quizData.end_datetime != null && this.quizData.end_datetime != ''){
            data.end_time = this.quizData.end_datetime;
          }else{
            data.end_time = null
          }
          this.$store.dispatch('updateInterviewQuizInfoAction', {
              data: {
                data: data,
                id: this.$route.params.quizId
              }
            }).then((res) => {
              if (res.status == '200') {
                toast.success(res.data.msg);
                this.$router.push('/interview/quiz/' )
              }
            })
            .catch((err) => {})
          return
        }
      });
    },
  },
  watch: {

  }
}
